import BusinessInfo from './BusinessInfo.page';

export default BusinessInfo;